import { Component, OnInit, inject } from '@angular/core';

import { InboxService as CoreInboxService } from '@frontend/vanilla/core';

import { InboxService } from '../services/inbox.service';
import { InboxComponent } from './inbox.component';

@Component({
    imports: [InboxComponent],
    selector: 'vn-inbox-view',
    templateUrl: 'inbox-view.html',
})
export class InboxViewComponent implements OnInit {
    private coreInboxService = inject(CoreInboxService);
    private inboxService = inject(InboxService);

    ngOnInit() {
        this.coreInboxService.set(this.inboxService);
    }
}
